import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {lightTheme} from '@components/@theme/lightTheme';
import {CircleXIcon} from '@components/icon/CircleXIcon';

interface SmartAlertContextTitleProps {
  icon?: any;
  onClose: () => void;
}

export const SmartAlertContextTitle: React.FC<SmartAlertContextTitleProps> = props => {
  const css = useStyles(lightTheme);
  return (
    <div className={css.wrapper}>
      {props.children}
      <div className={css.icons}>
        {props.icon && <props.icon />}
        <CircleXIcon className={css.close} onClick={props.onClose} tooltip="Remove" />
      </div>
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  wrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 10,
    padding: 20,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 4,
    boxShadow: '0 4px 12px 0 rgba(0,49,130,0.18)',
    '&:hover .close': {
      visibility: 'visible',
    },
  },
  icons: {
    height: 20,
    display: 'flex',
    fill: theme.palette.icon.grey,
  },
  close: {
    marginLeft: 10,
    visibility: 'hidden',
    cursor: 'pointer',
    fill: theme.palette.icon.grey,
  },
}));
